export class StandartAndGuidance {
  standartAndGuidanceId?: number;
  clientITProfileId?: number;
  identificationNumber?: string;
  title?: string;
  date?: number;
  link?: number;
}
